import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShiftListViewer } from './UpcomingShiftsPage.jsx';
import StorePage from './StorePage.jsx';
import BusinessInvoiceCard from '../common/BusinessInvoiceCard.jsx';
import './CompletePaymentsPage.scss'
import { SHIFT_STATUSES } from '../../Constants.js';
import { NAVIGATION_OPTIONS } from '../BusinessConstants.js';
import useStore from '../../hooks/StoreHook.jsx';

const CompletePaymentsPage = () => {
  const navigate = useNavigate();
  const { shifts } = useStore();
  const allShifts = shifts !== null
    ? shifts.filter(shift => 
      (
        (shift.status === SHIFT_STATUSES.CONFIRMED && shift.endTime <= new Date().getTime()) || 
        shift.status === SHIFT_STATUSES.INVOICE.key || 
        shift.status === SHIFT_STATUSES.DISPUTED.key ||
        shift.status === SHIFT_STATUSES.COMPLETED.key
      ))
    : null;;
  const emptyText = 'No payments to complete';
  const viewShift = (selectedShift) => navigate(`/find/shift?id=${selectedShift._id}`);
  return (
    <StorePage mode={NAVIGATION_OPTIONS.PAYMENTS.mode}>
      <article className={'complete-payments-page'}>
        <h1 className={'complete-payments-title'}>{'Pay For Completed Shifts'}</h1>
        <p className={'complete-payments-subtitle'}>
          {`Below are completed shifts that require payment. Easy instructions can be found on the invoice.`}
        </p>
        <p className={'complete-payments-subtitle'}>
          {`If you encounter an issue with a shift, get in touch with us.`}
        </p>
        <section className={'shift-viewer-container'}>
          <ShiftListViewer shifts={allShifts} CardComponent={BusinessInvoiceCard} emptyText={emptyText} select={viewShift} />
        </section>
      </article>
    </StorePage>
  );
}

export default CompletePaymentsPage;
